export default function CurrentOrganisationProvider() {
  this.$get = ($auth, $routeParams, $http, $t, $alert) => {
    'ngInject';

    function CurrentOrganisationProvider() {

      const self = this;

      self.getType = (callback) => {
        if (self.organisation && self.organisation.id === $routeParams.orgId) {
          callback(self.organisation.type)
        } else {
          self.load(callback);
        }
      }

      self.load = (callback) => {
        if (!$routeParams.orgId) {
          callback();
          return;
        }

        onLoad(response => {
            self.organisation = response.data;
            callback ? callback(self.organisation.type) : undefined;
          },
          error => $alert.processError(error, $t('organisation_owner.select_organisation.loading_organisation_error_message')));
      }

      self.currentOrganisation = () => self.organisation;

      const onLoad = (success, error) => {
        $auth.currentUser(() => {
          let path;
          if ($auth.isBikeOrganisationOwner()) {
            path = '/api/v1/fo/organisation-owner/organisations/' + $routeParams.orgId;
          } else if ($auth.isAdmin()) {
            path = '/api/v1/fo/admin/organisations/' + $routeParams.orgId;
          }

          $http.get(path)
            .then(success)
            .catch(error);
        });
      }

      self.set = organisation => self.organisation = organisation;

      self.isFleet = () => self.organisation && self.organisation.type === 'FLEET';

      self.isBrand = () => self.organisation && self.organisation.type === 'BRAND';
    }

    return new CurrentOrganisationProvider();
  };
}